/* ═══════════════════════════════════════════════════════════════════
   APTUX WAY — Reveal on scroll
   Adds .visible class to any element with .aw-reveal when it enters
   the viewport. Single observer for performance.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  if (typeof IntersectionObserver === 'undefined') {
    // Fallback: show everything immediately
    document.querySelectorAll('.aw-reveal').forEach(function (el) {
      el.classList.add('visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  function observeAll() {
    document.querySelectorAll('.aw-reveal:not(.visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Fallback safety: ensure everything becomes visible within 1.5s even if observer misfires
  setTimeout(function () {
    document.querySelectorAll('.aw-reveal:not(.visible)').forEach(function (el) {
      el.classList.add('visible');
    });
  }, 1500);

  // Re-scan when Shopify editor adds new blocks
  document.addEventListener('shopify:section:load', observeAll);
  document.addEventListener('shopify:block:select', observeAll);
})();
